import {
  AlertIcon,
  IndicatorLabel,
  IndicatorLabelColor,
  LinkedIcon,
  PendingIcon,
  UnlinkIcon,
} from "@codat/orchard-ui";
import { DataConnection } from "api/public";
import React from "react";

import styles from "./ConnectionStatusPill.module.scss";

interface StatusPillProps {
  status: DataConnection["status"];
}

const options: Record<
  string,
  {
    label: string;
    color?: IndicatorLabelColor;
    leftIcon?: React.ReactNode;
  }
> = {
  Linked: {
    label: "Linked",
    color: "positive",
    leftIcon: <LinkedIcon />,
  },
  PendingAuth: {
    label: "Pending auth",
    leftIcon: <PendingIcon />,
  },
  Unlinked: {
    label: "Unlinked",
    leftIcon: <UnlinkIcon />,
    color: "interface",
  },
  Deauthorized: {
    label: "Deauthorized",
    leftIcon: <AlertIcon />,
    color: "warning",
  },
};

export const ConnectionStatusPill = ({ status }: StatusPillProps) => {
  if (!status) return null;

  const props = options[status];

  return (
    <IndicatorLabel
      {...props}
      data-testid="connection-status"
      className={styles.pill}
    />
  );
};
